import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
  children?: React.ReactNode;
  vertical?: boolean;
  horizontal?: boolean;
};

export const CardSection = ({ className, children, vertical, horizontal = true }: Props): JSX.Element => {
  return (
    <div
      className={twMerge(
        cx({
          'px-24 md:px-32': horizontal,
          'py-24 md:py-32': vertical,
        }),
        className,
      )}
    >
      {children}
    </div>
  );
};
